import { AppProvider, useAppContext } from "./app";

const AppContext = {
	Provider: AppProvider,
	useAppContext
};

export default AppContext;
export { AppContext };
